import { conversation } from 'services';
import { API_CONVERSATION_STATUS } from 'utils/constants';

const getAllStatusService = () => {
  return conversation.get(API_CONVERSATION_STATUS);
};

export { getAllStatusService };
